import React, { ReactElement } from 'react'
import { LoginForm } from '../../Molecules/LoginForm/LoginForm'
import { WelcomeContainer } from '../WelcomeContainer/WelcomeContainer'
import { Branding } from '../../../../React/Common/API/BrandingAPI'
import { useBranding } from '../../../../React/Common/Hooks/useBranding'

export const Authentication = (): ReactElement => {
    const branding: Nullable<Branding> = useBranding()

    return (
        <WelcomeContainer>
            <LoginForm branding={branding} />
        </WelcomeContainer>
    )
}
